/**
 * A class to represent structured field tokens when `Symbol` is not available.
 *
 * @group Structured Field
 *
 * @beta
 */
export class SfToken {
    description;
    constructor(description) {
        this.description = description;
    }
}
//# sourceMappingURL=SfToken.js.map